<template>
  <div class="page cross-rate-page">
    <div class="header">
      <div class="title">
        {{
          isEdit
            ? `Редактируем Кросс Курс ${$route.params["id"]}`
            : `Добавляем Кросс Курс`
        }}
      </div>
    </div>
    <div class="content">
      <el-card shadow="always" class="main-card" v-loading="loading">
        <!-- <div slot="header" style="max-height: 300px; overflow:scroll;">
          <pre>{{ crType }}</pre>
          <pre>{{ data }}</pre>
          <pre>{{ cityReference }}</pre>
          <pre>{{ fromReference }}</pre>
          <pre>{{ toReference }}</pre>
        </div> -->
        <div v-if="!loading">
          <el-form
            @submit.prevent="SubmitCrossRate()"
            ref="dataForm"
            :model="data"
            label-width="250px"
          >
            <el-form-item
              label="From (мы покупаем)"
              prop="from"
              :rules="validation.from.rules"
            >
              <el-select
                class="bottom-space"
                placeholder="From"
                clearable
                filterable
                required
                v-model="data.from"
              >
                <el-option
                  v-for="item in valutes"
                  :key="item._id"
                  :label="item.title + ' - ' + item.key"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="To (мы продаем)"
              prop="to"
              :rules="validation.to.rules"
            >
              <el-select
                class="bottom-space"
                placeholder="To"
                clearable
                filterable
                required
                v-model="data.to"
              >
                <el-option
                  v-for="item in valutes"
                  :key="item._id"
                  :label="item.title + ' - ' + item.key"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="
                (fromReference && fromReference.isCash) ||
                  (toReference && toReference.isCash)
              "
              label="Город"
              prop="city"
              :rules="validation.city.rules"
            >
              <el-select
                class="bottom-space"
                placeholder="Город"
                clearable
                filterable
                v-model="data.city"
              >
                <el-option
                  v-for="item in valuteCities"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Текущий курс">
              <el-col :span="24" :offset="0">
                <span>{{ data.out }}</span>
                <el-popover placement="right" trigger="hover">
                  <el-alert
                    :type="
                      fromReference && toReference && data.out !== 'undefined'
                        ? 'info'
                        : 'warning'
                    "
                    show-icon
                    :closable="false"
                  >
                    <div
                      v-if="
                        fromReference && toReference && data.out !== 'undefined'
                      "
                    >
                      <div>
                        Нам присылают 1
                        {{
                          fromReference ? fromReference.bestchangeKey : "..."
                        }}, мы отправляем
                        {{
                          data.out ? parseFloat(data.out).toFixed(12) : "..."
                        }}
                        {{ toReference ? toReference.bestchangeKey : "..." }}
                      </div>
                      <div>
                        Нам присылают
                        {{
                          data.out
                            ? (
                                1 / parseFloat(parseFloat(data.out).toFixed(12))
                              ).toFixed(12)
                            : "..."
                        }}
                        {{
                          fromReference ? fromReference.bestchangeKey : "..."
                        }}, мы отправляем 1
                        {{ toReference ? toReference.bestchangeKey : "..." }}
                      </div>
                    </div>
                    <div v-else>
                      <div>
                        Выберите валюты и введите курс для отображения подсказки
                      </div>
                    </div>
                  </el-alert>
                  <el-button
                    slot="reference"
                    icon="el-icon-info"
                    circle
                  ></el-button>
                </el-popover>
              </el-col>
            </el-form-item>
            <el-form-item label="Кросс-курс активен?">
              <el-switch v-model="data.isActive"></el-switch>
            </el-form-item>

            <el-alert
              v-if="
                (fromReference && fromReference.isCash) ||
                  (toReference && toReference.isCash)
              "
              :type="'warning'"
              show-icon
              :closable="false"
            >
              <template slot="title">
                Внимание!
              </template>
              <div>
                В качестве одной из валют выбрана наличка.
              </div>
              <div>
                Итоговые лимиты будут учитывать дополнительную комиссию за
                доставку!
              </div>
              <div v-if="cityReference">
                Множитель за доставку в городе
                {{ cityReference.name }} составляет
                {{ cityReference.courierCommissionPercent }}
              </div>
              <div v-else>
                Выберите город, чтобы увидеть коэффициен комиссии.
              </div>
            </el-alert>

            <el-form-item label="Тип кросс-курса">
              <el-radio-group v-model="crType">
                <el-radio-button label="isDisabled"
                  >Скрытый кросс-курс</el-radio-button
                >
                <el-radio-button label="makeTopIsActive"
                  >В топ Беста</el-radio-button
                >
                <el-radio-button label="makePlaceIsActive"
                  >На позицию Беста</el-radio-button
                >
                <el-radio-button label="isFixed">Фиксированный</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div v-if="crType === 'isDisabled'" style="padding-bottom:20px">
              <el-card shadow="always" :body-style="{ padding: '20px' }">
                <div slot="header">
                  <span>
                    Скрывает данный кросс-курс из наших курсов. Не будет
                    отображаться на сайте и на бесте.
                  </span>
                </div>
                Используйте, если хотите временно или постоянно выключить
                определенное направление обмена.
              </el-card>
            </div>

            <div
              v-if="crType === 'makeTopIsActive'"
              style="padding-bottom:20px"
            >
              <el-card shadow="always" :body-style="{ padding: '20px' }">
                <div slot="header">
                  <span>
                    Будет пытаться вывести данное направление обмена максимально
                    высоко в топе Беста, с учетом лимита.
                  </span>
                </div>

                <el-form-item
                  :label="`Лимитный коэффициент`"
                  prop="makeTopLimitMult"
                >
                  <el-col :span="12">
                    <el-input
                      v-model="data.makeTopLimitMult"
                      type="number"
                      min="0"
                      max="3"
                      step="0.001"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                      type="primary"
                      @click="handleSetDefaultMakeTopLimitPercent()"
                    >
                      Установить лимит из валют
                    </el-button>
                    <!-- <el-popover placement="right" trigger="hover">
                      <el-alert
                        title="info alert"
                        :type="
                          fromReference && toReference && data.makeTopLimitMult
                            ? 'info'
                            : 'warning'
                        "
                        show-icon
                        :closable="false"
                      >
                        <template slot="title">
                          Подсказка
                        </template>
                        <div
                          v-if="
                            fromReference &&
                              toReference &&
                              data.makeTopLimitMult
                          "
                        >
                          <div
                            v-if="
                              (fromReference && fromReference.isCash) ||
                                (toReference && toReference.isCash)
                            "
                          >
                            <div>
                              Используя текущие курсы и с учетом множителя
                              доставки, получатся следующие лимиты:
                            </div>
                            <div v-if="cityReference">
                              <div>
                                Не дороже
                                {{
                                  fromReference.course &&
                                  toReference.course &&
                                  data.makeTopLimitMult
                                    ? (
                                        parseFloat(fromReference.course) /
                                        (parseFloat(toReference.course) *
                                          parseFloat(data.makeTopLimitMult) *
                                          cityReference.courierCommissionPercent)
                                      ).toFixed(12)
                                    : "..."
                                }}
                                {{ toReference.bestchangeKey }} за 1
                                {{ fromReference.bestchangeKey }}
                              </div>
                              <div>
                                Не дешевле
                                {{
                                  (
                                    1 /
                                    (parseFloat(fromReference.course) /
                                      (parseFloat(toReference.course) *
                                        parseFloat(data.makeTopLimitMult) *
                                        cityReference.courierCommissionPercent))
                                  ).toFixed(12)
                                }}
                                {{ fromReference.bestchangeKey }} за 1
                                {{ toReference.bestchangeKey }}
                              </div>
                            </div>
                            <div v-else>
                              Город не выбран, лимиты будут пересчитаны согласно
                              множителям из справочника Города
                            </div>
                          </div>
                          <div v-else>
                            <div>
                              Используя текущие курсы, получатся следующие
                              лимиты:
                            </div>
                            <div>
                              Не дороже
                              {{
                                fromReference.course &&
                                toReference.course &&
                                data.makeTopLimitMult
                                  ? (
                                      parseFloat(fromReference.course) /
                                      (parseFloat(toReference.course) *
                                        parseFloat(data.makeTopLimitMult))
                                    ).toFixed(12)
                                  : "..."
                              }}
                              {{ toReference.bestchangeKey }} за 1
                              {{ fromReference.bestchangeKey }}
                            </div>
                            <div>
                              Не дешевле
                              {{
                                (
                                  1 /
                                  (parseFloat(fromReference.course) /
                                    (parseFloat(toReference.course) *
                                      parseFloat(data.makeTopLimitMult)))
                                ).toFixed(12)
                              }}
                              {{ fromReference.bestchangeKey }} за 1
                              {{ toReference.bestchangeKey }}
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          Выберите валюты и заполните лимиты для получения
                          подсказки
                        </div>
                      </el-alert>
                      <el-button
                        slot="reference"
                        icon="el-icon-info"
                        circle
                      ></el-button>
                    </el-popover> -->
                  </el-col>
                </el-form-item>
                <el-form-item label="Отступ" prop="makeTopStep">
                  <el-col :span="8">
                    <el-input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Отступ"
                      v-model="data.makeTopStep"
                      :required="data.makeTopIsActive"
                    >
                      <template slot="append">{{
                        toReference && toReference.bestchangeKey
                          ? toReference.bestchangeKey
                          : ""
                      }}</template>
                    </el-input>
                  </el-col>
                  <el-col :span="16">
                    <!-- <div style="padding-left:0.5rem" v-if="recomendedStep">
                      Рекомендованный отступ: {{ recomendedStep }}
                      <el-button
                        type="primary"
                        size="mini"
                        @click="setMakeTopStep(recomendedStep)"
                        >Установить</el-button
                      >
                    </div> -->
                    <div style="padding-left:0.5rem" v-if="recomendedStep">
                      Рассчетный отступ: {{ calculatedStep }}
                      <el-button
                        type="primary"
                        size="mini"
                        @click="setMakeTopStep(calculatedStep)"
                        >Установить</el-button
                      >
                    </div>
                    <!-- <el-popover placement="right" trigger="hover">
                      <el-alert
                        title="info alert"
                        :type="
                          fromReference &&
                          toReference &&
                          data.out !== 'undefined' &&
                          data.makeTopStep
                            ? 'info'
                            : 'warning'
                        "
                        show-icon
                        :closable="false"
                      >
                        <template slot="title">
                          Подсказка
                        </template>
                        <div
                          v-if="
                            fromReference &&
                              toReference &&
                              data.out !== 'undefined' &&
                              data.makeTopStep
                          "
                        >
                          <div>
                            Если у конкурента курс
                            {{ parseFloat(data.out).toFixed(12) }}
                            {{
                              toReference ? toReference.bestchangeKey : "..."
                            }}
                            за 1
                            {{
                              fromReference
                                ? fromReference.bestchangeKey
                                : "..."
                            }}, то мы выставим курс
                            {{
                              parseFloat(
                                parseFloat(data.out) +
                                  parseFloat(data.makeTopStep)
                              ).toFixed(12)
                            }}
                            {{
                              toReference ? toReference.bestchangeKey : "..."
                            }}
                            за 1
                            {{
                              fromReference
                                ? fromReference.bestchangeKey
                                : "..."
                            }}:
                          </div>
                          <div>
                            И станет:
                          </div>
                          <div>
                            Нам присылают 1
                            {{
                              fromReference
                                ? fromReference.bestchangeKey
                                : "..."
                            }}, мы отправляем
                            {{
                              data.out
                                ? parseFloat(
                                    parseFloat(data.out) +
                                      parseFloat(data.makeTopStep)
                                  ).toFixed(12)
                                : "..."
                            }}
                            {{
                              toReference ? toReference.bestchangeKey : "..."
                            }}
                          </div>
                          <div>
                            Нам присылают
                            {{
                              data.out
                                ? (
                                    1 /
                                    parseFloat(
                                      parseFloat(
                                        parseFloat(data.out) +
                                          parseFloat(data.makeTopStep)
                                      ).toFixed(12)
                                    )
                                  ).toFixed(12)
                                : "..."
                            }}
                            {{
                              fromReference
                                ? fromReference.bestchangeKey
                                : "..."
                            }}, мы отправляем 1
                            {{
                              toReference ? toReference.bestchangeKey : "..."
                            }}
                          </div>
                        </div>
                        <div v-else>
                          Выберите валюты, заполните курс и введите отступ для
                          получения подсказки
                        </div>
                      </el-alert>

                      <el-button
                        slot="reference"
                        icon="el-icon-info"
                        circle
                      ></el-button>
                    </el-popover> -->
                  </el-col>
                </el-form-item>
                <div></div>
                <el-form-item
                  label="Не конкуренты"
                  prop="makeTopIgnoredExchangeNames"
                >
                  <el-select
                    class="bottom-space"
                    placeholder="Не конкуренты"
                    clearable
                    filterable
                    multiple
                    v-model="data.makeTopIgnoredExchangeNames"
                  >
                    <el-option
                      v-for="item in sourceProjects.docs.filter(
                        o => o.option === true
                      )"
                      :key="item.bestchangeName"
                      :label="item.name"
                      :value="item.bestchangeName"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="Что делать, если пусто в топе?"
                  prop="makeTopNoResultsStrategy"
                >
                  <el-select
                    class="bottom-space"
                    placeholder="Что делать, если пусто в топе?"
                    clearable
                    filterable
                    v-model="data.makeTopNoResultsStrategy"
                  >
                    <el-option
                      v-for="item in makeTopNoResultsStrategyValues"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-card>
            </div>

            <div
              v-if="crType === 'makePlaceIsActive'"
              style="padding-bottom:20px"
            >
              <el-card shadow="always" :body-style="{ padding: '20px' }">
                <div slot="header">
                  <span>
                    Будет пытаться держать данное направление обмена на
                    определенном месте в топе Беста.
                  </span>
                </div>
                <el-form-item
                  :label="`Желаемое место в топе`"
                  prop="makePlaceNumber"
                >
                  <el-input-number
                    v-model="data.makePlaceNumber"
                    :min="1"
                    :step="1"
                  ></el-input-number>
                </el-form-item>

                <el-form-item label="Отступ" prop="makePlaceStep">
                  <el-col :span="8">
                    <el-input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Отступ"
                      v-model="data.makePlaceStep"
                    >
                      <template slot="append">{{
                        toReference && toReference.bestchangeKey
                          ? toReference.bestchangeKey
                          : ""
                      }}</template>
                    </el-input>
                  </el-col>
                  <el-col :span="16">
                    <!-- <div style="padding-left:0.5rem" v-if="recomendedStep">
                      Рекомендованный отступ: {{ recomendedStep }}
                      <el-button
                        type="primary"
                        size="mini"
                        @click="setMakePlaceStep(recomendedStep)"
                        >Установить</el-button
                      >
                    </div> -->
                    <div style="padding-left:0.5rem" v-if="recomendedStep">
                      Рассчетный отступ: {{ calculatedStep }}
                      <el-button
                        type="primary"
                        size="mini"
                        @click="setMakePlaceStep(calculatedStep)"
                        >Установить</el-button
                      >
                    </div>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="Не конкуренты"
                  prop="makePlaceIgnoredExchangeNames"
                >
                  <el-select
                    class="bottom-space"
                    placeholder="Не конкуренты"
                    clearable
                    filterable
                    multiple
                    v-model="data.makePlaceIgnoredExchangeNames"
                  >
                    <el-option
                      v-for="item in sourceProjects.docs.filter(
                        o => o.option === true
                      )"
                      :key="item.bestchangeName"
                      :label="item.name"
                      :value="item.bestchangeName"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="Что делать, если места нет?"
                  prop="makePlaceNoResultsStrategy"
                >
                  <el-select
                    class="bottom-space"
                    placeholder="Что делать, если места нет?"
                    clearable
                    filterable
                    v-model="data.makePlaceNoResultsStrategy"
                  >
                    <el-option
                      v-for="item in makePlaceNoResultsStrategyValues"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-card>
            </div>

            <div v-if="crType === 'isFixed'" style="padding-bottom:20px">
              <el-card shadow="always" :body-style="{ padding: '20px' }">
                <div slot="header">
                  <span>
                    Просто присваивает введенный фиксированный курс. Внимание,
                    курс всегда будет таким, которым его ввели здесь, он
                    меняться не будет. Курс нужно вводить в том виде, который
                    принимает Bestchange - то есть сколько мы отдадим валюты To
                    за одну единицу валюты From.
                  </span>
                </div>
                <el-form-item label="Фиксированный курс">
                  <el-col :span="12">
                    <el-input
                      placeholder="Фиксированный курс"
                      v-model="fixedOut"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-card>
            </div>

            <!-- <el-form-item label="Отключить направление">
              <el-switch v-model="data.isDisabled"></el-switch>
            </el-form-item>

            <el-form-item label="Выводить в топ Bestchange">
              <el-switch v-model="data.makeTopIsActive"></el-switch>
            </el-form-item> -->
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-popconfirm
              title="Вернуться к списку? Все несохраненные изменения пропадут!"
              @confirm="$router.push({ name: 'CrossRate' })"
              :disabled="loading"
            >
              <el-button :loading="loading" type="danger" slot="reference"
                >Вернуться</el-button
              >
            </el-popconfirm>

            <el-button
              :loading="loading"
              @click="SubmitCrossRate"
              :disabled="loading"
              type="primary"
              >Сохранить</el-button
            >
            <el-button
              :loading="loading"
              @click="handleShowBestchangePreview"
              :disabled="loading"
              type="success"
              >Предпросмотр</el-button
            >
          </span>
        </div>
        <div v-else>
          <div v-if="errored">
            Произошла ошибка при загрузке кросс-курса, попробуйте еще раз
          </div>
          <div v-else>Загрузка...</div>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="Предпросмотр"
      :visible.sync="bestchangePreviewVisible"
      width="80%"
      :destroy-on-close="true"
      @close=""
    >
      <div v-if="bestchangePreviewVisible">
        <BestchangePreview
          :inputData="{ ...data, fixedOut }"
          :closeHandler="handleCloseBestchangePreview"
        />
      </div>
      <span slot="footer">
        <el-button @click="bestchangePreviewVisible = false">Закрыть</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCrossRate, getProjects, getValuteCities } from "@/api";
import validation from "../validation";
import { mapState, mapActions } from "vuex";
import BestchangePreview from "../../../ui/BestchangePreview.vue";

const makeTopNoResultsStrategyValues = [
  {
    label: "Использовать курс по лимиту",
    value: "useMakeTopLimitMult"
  },
  {
    label: "Использовать наш курс",
    value: "useOurRate"
  }
  // {
  //   label: "Не выводить вообще",
  //   value: "drop"
  // }
];
const makePlaceNoResultsStrategyValues = [
  {
    label: "Использовать наш курс",
    value: "useOurRate"
  }
  // {
  //   label: "Не выводить вообще",
  //   value: "drop"
  // }
];

const newCrossRateData = {
  out: 0,
  isActive: true,
  isDisabled: false,
  makeTopIsActive: false,
  makeTopLimitMult: 1.5,
  makeTopStep: 0,
  makeTopIgnoredExchangeNames: ["CatBit"],
  makeTopNoResultsStrategy: "useOurRate",
  makePlaceIsActive: false,
  makePlaceNumber: 3,
  makePlaceStep: 0,
  makePlaceIgnoredExchangeNames: ["CatBit"],
  makePlaceNoResultsStrategy: "useOurRate",
  isFixed: false,
  from: undefined,
  to: undefined,
  city: undefined
};

export default {
  name: "CrossRateEditOrNewForm",
  components: { BestchangePreview },
  data() {
    return {
      loading: true,
      errored: false,
      validation,
      data: null,
      sourceProjects: [],
      valuteCities: [],
      crType: undefined,
      fixedOut: 0,
      makeTopNoResultsStrategyValues,
      makePlaceNoResultsStrategyValues,
      bestchangePreviewVisible: false
    };
  },
  computed: {
    ...mapState("crossRate", ["valutes"]),
    isEdit() {
      return this.$route && this.$route.params && this.$route.params["id"];
    },
    fromReference() {
      return this.data && this.valutes.find(v => v._id === this.data.from);
    },
    toReference() {
      return this.data && this.valutes.find(v => v._id === this.data.to);
    },
    cityReference() {
      return this.data && this.valuteCities.find(v => v._id === this.data.city);
    },
    hasCash() {
      return (
        (this.fromReference && this.fromReference.isCash) ||
        (this.toReference && this.toReference.isCash)
      );
    },
    directRate() {
      //This is just for reference, not a real rate!!!
      if (!this.fromReference || !this.toReference) return;
      return parseFloat(this.fromReference.course / this.toReference.course);
    },
    recomendedStep() {
      //This is just an estimate
      if (!this.fromReference || !this.toReference) return;
      const rate = parseFloat(
        this.fromReference.course / this.toReference.course
      );
      if (!rate) return;
      const exp = parseInt(rate.toExponential().split("e")[1]);
      return exp >= 0 ? 0.01 : parseFloat(0.000001 * Math.pow(10, exp));
    },
    calculatedStep() {
      //This works well!!
      if (!this.directRate) return;
      return this.directRate > 1
        ? 0.01
        : this.directRate - 1 / (1 / this.directRate + 0.01);
    }
  },
  watch: {
    hasCash(val) {
      if (!val) this.data.city = undefined;
    },
    crType(val) {
      this.data = {
        ...this.data,
        isDisabled: false,
        makeTopIsActive: false,
        makePlaceIsActive: false,
        isFixed: false
      };
      if (val) {
        this.data = {
          ...this.data,
          [val]: true
        };
      }
    }
  },
  methods: {
    ...mapActions("crossRate", [
      "getValutes",
      "deleteCrossRate",
      "addCrossRate",
      "editCrossRate"
    ]),
    handleSetDefaultMakeTopLimitPercent() {
      if (this.fromReference && this.toReference) {
        this.data.makeTopLimitMult = parseFloat(
          // this.fromReference.percentGet / this.toReference.percentGive
          (
            this.toReference.percentGet / this.fromReference.percentGive
          ).toFixed(6)
        );
      }
    },
    handleCloseBestchangePreview() {
      this.bestchangePreviewVisible = false;
    },
    handleShowBestchangePreview() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.bestchangePreviewVisible = true;
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
        }
      });
    },
    setMakeTopStep(step) {
      this.data.makeTopStep = step;
    },
    setMakePlaceStep(step) {
      this.data.makePlaceStep = step;
    },
    SubmitCrossRate() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          await this.submitter();
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
        }
      });
    },
    async submitter() {
      const crossRate = { ...this.data, fixedOut: this.fixedOut };
      if (!crossRate.city) {
        crossRate.city = null;
      }
      try {
        this.loading = true;
        if (crossRate._id) {
          await this.editCrossRate(crossRate);
        } else {
          const newCR = await this.addCrossRate(crossRate);
          if (
            newCR &&
            newCR.data &&
            newCR.data.result &&
            newCR.data.result._id
          ) {
            this.$router.push({
              name: "CrossRateEdit",
              params: { id: newCR.data.result._id }
            });
          }
        }
        await this.loadData();
        await this.$message.success("Операция прошла успешно");
      } catch (error) {
        this.$message({
          type: "error",
          message: error.response.data.message || "Ошибка!"
        });
      } finally {
        this.loading = false;
      }
    },
    async loadAssets() {
      const projects = await getProjects({
        limit: 1000,
        query: { $and: [{ option: true }, { bestchangeName: { $ne: null } }] }
      });
      this.sourceProjects = projects.data.result;
      const valuteCities = await getValuteCities({
        limit: 1000,
        query: { isActive: true }
      });
      this.valuteCities = valuteCities.data.result.docs;
      await this.getValutes();
    },
    async loadData() {
      await this.loadAssets();
      const result = await getCrossRate(this.$route.params["id"]);
      this.data = result.data;
      if (this.data.isDisabled) this.crType = "isDisabled";
      if (this.data.makeTopIsActive) this.crType = "makeTopIsActive";
      if (this.data.makePlaceIsActive) this.crType = "makePlaceIsActive";
      if (this.data.isFixed) {
        this.crType = "isFixed";
      }
      this.fixedOut = this.data.out;
    }
  },
  async mounted() {
    if (this.isEdit) {
      try {
        this.loading = true;
        await this.loadData();
      } catch (error) {
        this.errored = true;
        console.log(error);
      } finally {
        this.loading = false;
      }
    } else {
      try {
        this.loading = true;
        await this.loadAssets();
        this.data = { ...newCrossRateData };
      } catch (error) {
        this.errored = true;
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CrossRate/edit/index.vue